<div class="permissions-header-container-tables">
    <span *ngIf="fullAccessPermission" class="center-item permission-name">{{strings["fullAccess"]}}</span>
    <span *ngIf="!fullAccessPermission" class="center-item permission-name">{{strings["admin"]}}</span>
    <span *ngIf="!fullAccessPermission" class="center-item permission-name">{{strings["edit"]}}</span>
    <span *ngIf="!fullAccessPermission" class="center-item permission-name">{{strings["read"]}}</span> 
</div>

<div class="permissions-checkbox-container-tables">
    <!-- Full Access Access checkbox -->
    <input *ngIf="fullAccessPermission"
        class="center-item checkbox" type="checkbox"
        [checked]="tablesFullAccessEnabled()"
        (click)="toggleTableAdmin()">
    <!-- Admin checkbox -->
    <input *ngIf="!fullAccessPermission"
        class="center-item checkbox" type="checkbox"
        [checked]="tableAdminEnabled()"
        (click)="toggleTablePermission('Admin')"
        [disabled]="tablesFullAccessEnabled()">
    <!-- Read checkbox -->
    <input *ngIf="!fullAccessPermission"
        class="center-item checkbox" type="checkbox"
        [checked]="tablePermissionEnabled('Write') || tableAdminEnabled()"
        (click)="toggleTablePermission('Write')"
        [disabled]="tableAdminEnabled()">
    <!-- Edit checkbox -->
    <input *ngIf="!fullAccessPermission"
        class="center-item checkbox" type="checkbox"
        [checked]="tablePermissionEnabled('Read') || tableAdminEnabled()"
        (click)="toggleTablePermission('Read')"
        [disabled]="tableAdminEnabled()">
</div>
